// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/article-page-news-intro/article-page-news-intro.component.scss
// module id = 106
// module chunks = 0